import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OdrService } from '../service/odr.service';

import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { people } from '../people-list/people-list.component';
import { Address, VCard, VCardEncoding, VCardFormatter } from 'ngx-vcard';


@Component({
  selector: 'app-people-details',
  templateUrl: './people-details.component.html',
  styleUrls: ['./people-details.component.css']
})
export class PeopleDetailsComponent implements OnInit {

  searchValue: string;
 
  public aFormGroup: FormGroup;
  
  peopleList: Array<people>;
  mothraId: string;
  peopleAuthText: string;

  public vCardEncoding: typeof VCardEncoding = VCardEncoding;
  public vCard: VCard = {};

  constructor(private odrService: OdrService, 
    public formBuilder: FormBuilder,  
    private activatedRoute: ActivatedRoute, private router: Router) {
      const navigation = router.getCurrentNavigation();
      this.mothraId = navigation.extras.state.mothraId;
      this.searchValue = navigation.extras.state.mothraId;
      this.getPeopleSearch();
   }

  ngOnInit(): void {
    
  this.aFormGroup = this.formBuilder.group({
      searchValue: new FormControl(null, Validators.required)
    });
  }

getPeopleSearch (): void {

  if (this.mothraId && this.mothraId !== '' && this.mothraId.length >= 1) {
        this.odrService.getPeopleList().subscribe(testStr => {
          this.peopleAuthText = testStr['getKey'];
          console.log("response: " + this.peopleAuthText + ", " + testStr);
          this.odrService.lookupContactDetails(this.mothraId, this.peopleAuthText).subscribe(resData => {
            resData.forEach(data => {
              let address: Address = {street: data.street, postalCode: data.zip };
              let vCard = { name: { firstNames: data.firsName, lastNames: data.lastName }, 
              email: [data.mail], address: [address], telephone: [data.telephoneNumber]  };
              data.vCard = vCard;
            });
            this.peopleList = resData;
         });
        });	       
     } 
     
 }



}